import { defineStore } from "pinia"
import { searchProduct } from "@/api/productApi"
import { showError } from "@/services/alertService"

export const useProductSearchStore = defineStore("productSearchStore", {
  state: () => ({
    searchProductQuery: null,
    products: [],
    page: 0,
    items: 0,
    total: 0,
    last: 0,
    isNotFound: false,
  }),

  getters: {
    getProducts(store) {
      return store.products
    },

    nextPage(store) {
      return store.page + 1
    },

    productNotFound(store) {
      return store.isNotFound
    },

    showInfo(store) {
      return {
        start: 1,
        items: store.items,
        total: store.total,
      }
    },
  },

  actions: {
    setProductQuery(query) {
      this.reset()

      if (query) {
        this.searchProductQuery = query
        this.loadProducts()
      }
    },

    reset() {
      this.page = 0
      this.items = 0
      this.total = 0
      this.last = 0
      this.products = []
      this.isNotFound = false
    },

    async loadProducts() {
      if (this.nextPage >= this.last && this.last > 0) return
      try {
        const { products, page } = await searchProduct(this.searchProductQuery, this.nextPage)

        this.products.push(...products)
        this.page = page.current
        this.items += page.items
        this.total = page.total
        this.last = page.last

        if (!this.products.length) this.isNotFound = true
      } catch (error) {
        showError(error.message)
        throw error
      }
    },
  },
})
